export function getApiBaseUrl() {
    if (typeof import.meta !== 'undefined') {
        const env = import.meta.env;
        if (env?.VITE_API_BASE_URL)
            return env.VITE_API_BASE_URL;
    }
    return '';
}
//# sourceMappingURL=config.js.map